import { createContext } from 'preact/compat';
const DatesCTX = createContext({
    availablePrices: [],
    lowAvailabilityDates: [],
    highAvailabilityDates: [],
    averageAvailabilityDates: [],
    soldOutDates: [],
    showAvailability: false,
});
export default DatesCTX;
